import Step3 from './Step3'
import ConnectedStep3 from './ConnectedStep3'
export {
    Step3,
}
export default ConnectedStep3
